export const MAX_IMAGES_FOR_PERIODIC_CHECK = 5;

export const PERIODIC_CHECK_DRAFT_STATUS = 3;